export const notification = {
  all: "Toutes",
  markAllButton: "Tout marquer comme lu",
  noData: "Aucune notification",
  settingsButton: "Paramètres de notification",
  unread: "Non lues",
  upToDate: "Vous êtes à jour",
  asyncDelete: {
    title: {
      organization: "Suppression d'organisation",
      location: "Suppression de localisation",
      asset: "Suppression d'actif",
      assets: "Suppression d'actifs",
    },
    description: {
      success: {
        organization:
          "L'organisation <strong><em>{{modelName}}</em></strong> et les données associées ont été supprimés avec succès.",
        location:
          "La location <strong><em>{{modelName}}</em></strong> et les données associées ont été supprimés avec succès.",
        asset:
          "L'actif <strong><em>{{modelName}}</em></strong> et les données associées ont été supprimés avec succès.",
        assets:
          "Les actifs <strong><em>{{modelName}}</em></strong> et les données associées ont été supprimés avec succès.",
        assetBatch:
          "Les actifs <strong><em>{{modelName}}</em></strong> et {{count}} autres actifs, ainsi que leurs données associées, ont été supprimés avec succès.",
      },
      failure:
        "Une erreur inattendue s'est produite lors de la suppression. L'équipe de développement a été avisée du problème et corrigera la situation sous peu.",
    },
  },
  jobModule: {
    completed: {
      title: "{{moduleName}}",
      description:
        "Le module “{{moduleName}}” est terminé - <strong><em>{{subjectName}}</em></strong>",
    },
    failed: {
      title: "Erreur de génération",
      description:
        "Une erreur s'est produite lors de la génération du module: <strong><em>{{moduleName}}</em></strong>. Veuillez contacter le support afin d'obtenir de l'aide.",
    },
  },
  observationCommented: {
    title: "Nouveau commentaire",
  },
  interventionTransition: {
    title_one: "Changement d'état de l'intervention",
    title_other: "Changement d'état des interventions",
    description_one:
      "{{userName}} a changé l'état de l'intervention «{{interventionName}}» à <StateTag/>.",
    description_other:
      "{{userName}} a changé l'état de {{count}} interventions à <StateTag/>.",
  },
  observationTransition: {
    title_one: "Changement d'état de l'observation",
    title_other: "Changement d'état des observations",
    description_one:
      "{{userName}} a changé l'état de l'observation «{{observationName}}» à <StateTag/>.",
    description_other:
      "{{userName}} a changé l'état de {{count}} observations à <StateTag/>.",
  },
};
